import 'utils/polyfills/intl'
import 'config/i18n'
import '@expo/metro-runtime'
import { registerRootComponent } from 'expo'
import { ExpoRoot } from 'expo-router'
import { enableFreeze } from 'react-native-screens'

enableFreeze()
// Must be exported or Fast Refresh won't update the context
export function App() {
  // @ts-expect-error - idk why this works
  const ctx = require.context('./app')
  return <ExpoRoot context={ctx} />
}

registerRootComponent(App)
